import React, { useMemo, useState } from 'react'
import { MouseClickAway } from '../../legacy/dropdown-search/mouse-click-away'
import { SEARCH_FIELD_PROPS } from '../../component/search-field-props'

export const SelectFilterObj = ({ items, itemKey, selectedItem, disabled, onChange }) => {
  const [search, updateSearch] = useState('')
  const [modeSearch, updateModeSearch] = useState(false)

  const filterItems = useMemo(
    () => {
      if (!items) {
        return []
      }

      const lowerSearch = search.toLowerCase()
      return items.filter(item => item[itemKey].toLowerCase().includes(lowerSearch))
    },
    [items, itemKey, search]
  )

  const handleChangeSearch = value => {
    updateSearch(value)
  }

  const handleShowSearch = () => {
    updateModeSearch(true)
  }

  const handleSelect = item => {
    updateModeSearch(false)
    onChange && onChange(item)
  }

  const handleMouseClickAway = () => updateModeSearch(false)

  const value = useMemo(() => (selectedItem && selectedItem[itemKey]) || 'SELECT', [selectedItem, itemKey])

  return (
    <React.Fragment>
      <MouseClickAway onClick={handleMouseClickAway}>
        {!modeSearch && <input className="form-control" value={value} disabled={disabled} onClick={handleShowSearch} />}
        {modeSearch &&
          <React.Fragment>
            <Filter value={search} onChange={handleChangeSearch} />
            <div className="dropdown-menu show" style={{ maxHeight: '60vh', maxWidth: '80vw', overflow: 'auto', direction: 'ltr' }}>
              {filterItems.length === 0
                ? <div className="dropdown-item">No Result</div>
                : <React.Fragment>
                    <Select onSelect={handleSelect} />
                    {filterItems.map((item, i) => <Item key={i} item={item} itemKey={itemKey} selectedItem={selectedItem} onSelect={handleSelect} />)}
                  </React.Fragment>}
            </div>
          </React.Fragment>}
      </MouseClickAway>
    </React.Fragment>
  )
}

const Filter = ({ value, onChange }) => {
  const handleChange = e => {
    e.preventDefault()
    e.stopPropagation()
    onChange && onChange(e.target.value)
  }
  const handleClear = () => onChange && onChange('')

  return (
    <div className="input-group">
      <input {...SEARCH_FIELD_PROPS} name="list-filter" aria-label="filter" className="form-control search-own-clear" value={value} placeholder="filter" autoFocus onChange={handleChange} />
      <span className="input-group-text" onClick={handleClear}>
        Clear
      </span>
    </div>
  )
}

const Select = ({ onSelect }) => {
  const handleSelect = () => onSelect && onSelect(null)
  return (
    <div className="dropdown-item" style={{ cursor: 'pointer' }} onClick={handleSelect}>
      SELECT
    </div>
  )
}

const Item = ({ item, itemKey, selectedItem, onSelect }) => {
  const isSelected = useMemo(() => item === selectedItem, [item, selectedItem])

  const handleSelect = () => onSelect && onSelect(item)

  return (
    <div className={`dropdown-item ${isSelected && 'bg-primary text-light'}`} style={{ cursor: 'pointer' }} onClick={handleSelect}>
      {item && item[itemKey]}
    </div>
  )
}
